import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import api, { formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Talebiniz alındı");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center p-6 bg-background acas-grid">
      <div className="w-full max-w-sm p-8 rounded-lg border border-border/60 bg-card acas-fade-up">
        <Link to="/giris" className="text-xs text-muted-foreground inline-flex items-center gap-1 hover:text-foreground mb-6" data-testid="back-to-login">
          <ArrowLeft size={14} /> Girişe dön
        </Link>
        <div className="acas-eyebrow mb-2">Parola Sıfırlama</div>
        <h2 className="text-2xl font-bold tracking-tight mb-2">Şifremi unuttum</h2>
        <p className="text-sm text-muted-foreground mb-6">
          E-posta adresinizi girin, sıfırlama bağlantısını gönderelim.
        </p>

        {!sent ? (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">E-posta</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                     data-testid="forgot-email" placeholder="siz@sirket.com" className="mt-1.5" />
            </div>
            <Button type="submit" disabled={busy} className="w-full" data-testid="forgot-submit">
              {busy ? "Gönderiliyor…" : "Sıfırlama bağlantısı gönder"}
            </Button>
          </form>
        ) : (
          <div className="rounded-md border border-primary/20 bg-primary/5 p-4 text-sm">
            <div className="font-semibold text-primary mb-1">Talebiniz alındı</div>
            <div className="text-muted-foreground">
              Eğer bu e-posta sisteme kayıtlı ise sıfırlama bağlantısı gönderildi.
              Lütfen gelen kutunuzu kontrol edin.
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
